import axiosInstance from "../../interceptor/axiosInstance";
import ApiRoutes from "../../routes/routeConstants/apiRoutes";
import { UserRoleEnum } from "../../enums/userRole.enum";
import { ListingColumnPreferenceRow } from "../../constants/listingColumnKeys";

export interface ListingColumnPreferencesResponse {
  listing_context: string;
  eligible_column_keys: string[];
  columns: ListingColumnPreferenceRow[];
}

function basePath(userRole: UserRoleEnum): string {
  if (userRole === UserRoleEnum.ADMIN) return ApiRoutes.ADMIN_LISTING_COLUMN_PREFERENCES;
  if (userRole === UserRoleEnum.DOCTOR) return ApiRoutes.DOCTOR_LISTING_COLUMN_PREFERENCES;
  return ApiRoutes.SCAN_CENTER_LISTING_COLUMN_PREFERENCES;
}

export default class ListingColumnPreferenceService {
  static fetch(
    userRole: UserRoleEnum,
    listingContext: string,
    onSuccess: (data: ListingColumnPreferencesResponse) => void,
    onError: () => void,
    onFinal: () => void
  ) {
    const url = `${basePath(userRole)}?listing_context=${encodeURIComponent(listingContext)}`;
    axiosInstance
      .get(url)
      .then((res) => {
        onSuccess(res.data as ListingColumnPreferencesResponse);
      })
      .catch(() => onError())
      .finally(() => onFinal());
  }

  static save(
    userRole: UserRoleEnum,
    listingContext: string,
    columns: ListingColumnPreferenceRow[],
    onSuccess: (data: { listing_context: string; columns: ListingColumnPreferenceRow[] }) => void,
    onError: () => void,
    onFinal: () => void
  ) {
    axiosInstance
      .put(basePath(userRole), {
        listing_context: listingContext,
        columns,
      })
      .then((res) => {
        onSuccess(res.data);
      })
      .catch(() => onError())
      .finally(() => onFinal());
  }
}
